import { confirmApproval, denyApproval, fetchApprovals } from '@/backend/distributionApi';

const getDefaultState = () => ({
  items: [],
  currentPage: 1,
  totalPages: 1,
  totalItems: 0,
  loading: false,
  statuses: [],
  trip: '',
  responsible: '',
  dateFrom: '',
  dateTo: '',
  approvalState: 'pending',
  page: 1,
  perPage: 50,
  requestSeq: 0,
  decisionLoading: {},
});

const state = getDefaultState();
const namespaced = true;

const mutations = {
  SET_LOADING(state, value) { state.loading = value; },
  SET_PAGE(state, value) { state.page = value; state.currentPage = value; },
  SET_STATUSES(state, value) { state.statuses = value; state.page = 1; state.currentPage = 1; },
  SET_TRIP(state, value) { state.trip = value; state.page = 1; state.currentPage = 1; },
  SET_RESPONSIBLE(state, value) { state.responsible = value; state.page = 1; state.currentPage = 1; },
  SET_DATE_FROM(state, value) { state.dateFrom = value; state.page = 1; state.currentPage = 1; },
  SET_DATE_TO(state, value) { state.dateTo = value; state.page = 1; state.currentPage = 1; },
  SET_APPROVAL_STATE(state, value) { state.approvalState = value; state.page = 1; state.currentPage = 1; },
  RESET_FILTERS(state) {
    state.statuses = [];
    state.trip = '';
    state.responsible = '';
    state.dateFrom = '';
    state.dateTo = '';
    state.approvalState = 'pending';
    state.page = 1;
    state.currentPage = 1;
  },
  SET_REQUEST_SEQ(state, value) { state.requestSeq = value; },
  SET_DECISION_LOADING(state, { uid, value }) {
    state.decisionLoading = { ...state.decisionLoading, [uid]: value };
  },
  SET_RESPONSE(state, response) {
    state.items = Array.isArray(response?.items) ? response.items : [];
    state.currentPage = Number.isFinite(response?.current_page) ? response.current_page : 1;
    state.totalPages = Number.isFinite(response?.total_pages) ? response.total_pages : 1;
    state.totalItems = Number.isFinite(response?.total_items) ? response.total_items : state.items.length;
  },
};

const actions = {
  async getApprovals({ commit, state }, options = {}) {
    const requestSeq = state.requestSeq + 1;
    commit('SET_REQUEST_SEQ', requestSeq);
    commit('SET_LOADING', true);
    try {
      const data = await fetchApprovals({
        page: state.page,
        per_page: state.perPage,
        statuses: state.statuses.length ? state.statuses : undefined,
        trip: state.trip || undefined,
        responsible: state.responsible || undefined,
        date_from: state.dateFrom || undefined,
        date_to: state.dateTo || undefined,
        approval_state: state.approvalState,
      });
      if (requestSeq === state.requestSeq) {
        commit('SET_RESPONSE', data);
      }
    } finally {
      if (requestSeq === state.requestSeq) {
        commit('SET_LOADING', false);
      }
    }
  },

  setPage({ commit, dispatch }, value) {
    commit('SET_PAGE', value);
    dispatch('getApprovals');
  },

  setStatuses({ commit, dispatch }, value) {
    commit('SET_STATUSES', value);
    dispatch('getApprovals');
  },

  setTrip({ commit, dispatch }, value) {
    commit('SET_TRIP', value);
    dispatch('getApprovals');
  },

  setResponsible({ commit, dispatch }, value) {
    commit('SET_RESPONSIBLE', value);
    dispatch('getApprovals');
  },

  setDateFrom({ commit, dispatch }, value) {
    commit('SET_DATE_FROM', value);
    dispatch('getApprovals');
  },

  setDateTo({ commit, dispatch }, value) {
    commit('SET_DATE_TO', value);
    dispatch('getApprovals');
  },

  setApprovalState({ commit, dispatch }, value) {
    commit('SET_APPROVAL_STATE', value);
    dispatch('getApprovals');
  },

  resetFilters({ commit, dispatch }) {
    commit('RESET_FILTERS');
    dispatch('getApprovals');
  },

  async decideApproval({ commit, dispatch }, { uid, decision }) {
    if (!uid) return;
    commit('SET_DECISION_LOADING', { uid, value: true });
    try {
      if (decision === 'confirm') {
        await confirmApproval(uid);
      } else {
        await denyApproval(uid);
      }
      await dispatch('getApprovals', { force: true });
    } finally {
      commit('SET_DECISION_LOADING', { uid, value: false });
    }
  },
};

export default {
  state,
  mutations,
  actions,
  namespaced,
};
